import { HttpClient } from '@angular/common/http';
import { computed, inject } from '@angular/core';

import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { CitiesList, CitiesRequest } from '../../models/energy-analysis.model';
import { EnergyAnalysisService } from '../../services/energy-analysis.service';

export interface EnergyAnalisyCitiesListStateModel {
  paginatedData: CitiesList;
  textSearch: string;
  currentPage: number;
  pageSize: number;
  isFetching: boolean;
  isLoading: boolean;
  isLoadingFilters: boolean;
}

const initialState: EnergyAnalisyCitiesListStateModel = {
  paginatedData: {
    elements: [],
    totalElements: 0,
    totalPages: 0,
  },
  textSearch: '',
  currentPage: 1,
  pageSize: 1000,
  isFetching: false,
  isLoading: false,
  isLoadingFilters: false,
};

export const EnergyAnalysisCitiesStore = signalStore(
  withState(initialState),
  withComputed(store => ({
    requestParameters: computed<CitiesRequest>(() => {
      return {
        text: store.textSearch(),
        orderByField: 'NAME',
        orderByDirection: 'ASC',
        page: store.currentPage(),
        pageSize: store.pageSize(),
      };
    }),
  })),
  withMethods((store, energyAnalysesService = inject(EnergyAnalysisService), http = inject(HttpClient)) => {
    const loadCities = () => {
      patchState(store, { isLoading: true });
      energyAnalysesService.searchCities(store.requestParameters()).subscribe({
        next: response => {
          patchState(store, {
            isLoading: false,
            paginatedData: {
              elements: [
                ...(store.currentPage() !== 1 ? (store.paginatedData?.()?.elements ?? []) : []),
                ...response.elements,
              ],
              totalElements: response.totalElements,
              totalPages: response.totalPages,
            },
          });
        },
        error: error => {
          console.error('Error loading cities', error);
          patchState(store, { isLoading: false });
        },
      });
    };

    return {
      loadCities,
      setCurrentPage: (page: number) => {
        if (page <= store.paginatedData().totalPages) patchState(store, { currentPage: page });
        loadCities();
      },
      setTextSearch: (text: string) => {
        patchState(store, { textSearch: text, currentPage: 1 });
        loadCities();
      },
      reload: () => {
        energyAnalysesService.bustCitiesCache();
        patchState(store, {
          paginatedData: { elements: [], totalElements: 0, totalPages: 0 },
          currentPage: 1,
        });
        loadCities();
      },
    };
  })
);
